import React from 'react';
import { AuthConsumer } from './AuthProvider';
import { LoadingScreen } from '@ibinder/common-frontend';

export const Logout = ({
  logoutText,
  waitText
}: {
  logoutText: string;
  waitText: string;
}) => (
  <AuthConsumer>
    {({ logout }) => {
      logout();
      return (
        <LoadingScreen
          statusMessage={logoutText}
          loadingText={waitText}
          fullscreen={true}
        />
      );
    }}
  </AuthConsumer>
);
